import type {ConnectElementConfig} from '../ConnectElementList';

export const treasuryEntryBannerIsVisibleParameter = 'visible' as const;

export const treasuryEntryBannerOnboardingRequiredParameter =
  'onboarding-required' as const;

export const TreasuryEntryBannerConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "treasuryEntryBanner" */
      '../../../components/MoneyManagement/TreasuryEntryBanner/TreasuryEntryBanner'
    ),
  releaseState: 'internal',
  sentryTeam: 'platform_surfaces_embedded',
  teamOwner: 'platform-surfaces',
  htmlAttributes: {
    [treasuryEntryBannerOnboardingRequiredParameter]: {isInternal: true},
    [treasuryEntryBannerIsVisibleParameter]: {
      isInternal: true,
    },
  },
  htmlEvents: ['close', 'treasuryentryctaclick', 'onboardingexited'],
  customHtmlElementMethods: {
    setOnboardingRequired: {
      type: 'AttributeSettingMethod',
      attribute: treasuryEntryBannerOnboardingRequiredParameter,
      isInternal: true,
      description:
        'Sets whether banner CTAs continue into financial account onboarding.',
    },
    setOnOnboardingStart: {
      type: 'EventListenerMethod',
      event: 'treasuryentryctaclick',
      isInternal: true,
      description: 'Called when the user opens financial account onboarding.',
    },
    setOnOnboardingExit: {
      type: 'EventListenerMethod',
      event: 'onboardingexited',
      isInternal: true,
      description:
        'Called when onboarding exits so the host can refresh account state.',
    },
    setIsVisible: {
      type: 'AttributeSettingMethod',
      attribute: treasuryEntryBannerIsVisibleParameter,
      isInternal: true,
      description: 'Sets whether the Treasury entry banner is visible.',
    },
    setOnClose: {
      type: 'EventListenerMethod',
      event: 'close',
      isInternal: true,
      description:
        'Sets the event listener called when the Treasury entry banner is dismissed.',
    },
  },
  description: 'Internal dismissible banner for EFS test accounts.',
  friendlyName: 'Treasury Entry Banner',
};
